var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.803 11.3333C19.803 9.49238 21.3022 8 23.1515 8C25.0008 8 26.5 9.49238 26.5 11.3333C26.5 13.1743 25.0008 14.6667 23.1515 14.6667C22.2177 14.6667 21.3738 14.286 20.7671 13.6735L16.1317 16.8295C16.1745 17.0425 16.197 17.2625 16.197 17.4872C16.197 17.9322 16.109 18.3576 15.9496 18.7464L21.0323 22.0858C21.6092 21.6161 22.3473 21.3333 23.1515 21.3333C25.0008 21.3333 26.5 22.8257 26.5 24.6667C26.5 26.5076 25.0008 28 23.1515 28C21.3022 28 19.803 26.5076 19.803 24.6667C19.803 24.1845 19.9062 23.7255 20.0917 23.3111L15.0501 19.9987C14.462 20.5098 13.6916 20.8205 12.8485 20.8205C10.9992 20.8205 9.5 19.3281 9.5 17.4872C9.5 15.6462 10.9992 14.1538 12.8485 14.1538C13.9119 14.1538 14.8585 14.6473 15.4714 15.4152L19.9639 12.3564C19.8594 12.0336 19.803 11.6896 19.803 11.3333Z",
    fill: "#00A991"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.b7aa338f5bc96c1315b3ff5ca287d889.svg";
export { ForwardRef as ReactComponent };